/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ConnectApiKeyDailymotionAuthMutationRequest, ConnectApiKeyDailymotionAuthMutationResponse, ConnectApiKeyDailymotionAuthPathParams } from "../models/ConnectApiKeyDailymotionAuth";

export function getConnectApiKeyDailymotionAuthUrl(station: ConnectApiKeyDailymotionAuthPathParams["station"]) {
  const res = { method: 'POST', url: `/auth/dailymotion/api-key/${station}` as const }
  return res
}

/**
 * @summary Connect with Dailymotion using a private API key
 * {@link /auth/dailymotion/api-key/:station}
 */
export async function connectApiKeyDailymotionAuth(station: ConnectApiKeyDailymotionAuthPathParams["station"], data: ConnectApiKeyDailymotionAuthMutationRequest, config: Partial<RequestConfig<ConnectApiKeyDailymotionAuthMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ConnectApiKeyDailymotionAuthMutationResponse, ResponseErrorConfig<Error>, ConnectApiKeyDailymotionAuthMutationRequest>({ method : "POST", url : getConnectApiKeyDailymotionAuthUrl(station).url.toString(), data : requestData, ... requestConfig })
  return res.data
}